export class NewsCaption {
  private el: HTMLDivElement;

  constructor(parent: HTMLElement) {
    this.el = document.createElement('div');
    this.el.className = 'news-caption';
    parent.append(this.el);
    this.hide();
  }

  set(text: string): void {
    this.el.textContent = text;
    this.el.style.display = '';
  }

  hide(): void { this.el.style.display = 'none'; }
}
